export enum LocalStoreEnum {
  Token = 'JWT_ADMIN',
  RefreshToken = 'RJWT_ADMIN',
  User_Infor = 'UI_ADMIN',
  Menu_List = 'ML_ADMIN',
  Menu_List_EMB = 'MLEMB',
  Time_Expiration = 'TE_ADMIN',
  Dform_Backup_Data = 'BKDFORM_ADMIN',
  Date_Expiration = 'DATE_ADMIN',
}
